import { FC } from 'react';

export const FX: FC = () => (
  <svg fill="currentColor" viewBox="0 0 496 496" strokeWidth="2">
    <g>
      <g>
        <g>
          <path
            d="M120,224c46.416,0,86.32-28.392,103.28-68.712C231.32,153.144,239.608,152,248,152c20.304,0,39.56,6.336,56,18.232V256
				h16V96h-19.44L376,26.848L451.44,96H432v176h16V112h44.56L376,5.152L259.44,112H304v39.16c-16.984-9.904-36.048-15.16-56-15.16
				c-6.424,0-12.8,0.608-19.088,1.688C230.864,129.424,232,120.856,232,112C232,50.24,181.76,0,120,0S8,50.24,8,112
				S58.24,224,120,224z M120,16c52.936,0,96,43.064,96,96c0,52.936-43.064,96-96,96c-52.936,0-96-43.064-96-96
				C24,59.064,67.064,16,120,16z"
          />
          <path
            d="M112,175.592V192h16v-16.408c17.952-2.016,32-17.112,32-35.592c0-19.848-16.152-36-36-36h-8c-11.032,0-20-8.976-20-20
				s8.968-20,20-20h8c11.032,0,20,8.976,20,20v4h16v-4c0-18.48-14.048-33.576-32-35.592V32h-16v16.408C94.048,50.424,80,65.52,80,84
				c0,19.848,16.152,36,36,36h8c11.032,0,20,8.976,20,20s-8.968,20-20,20h-8c-11.032,0-20-8.976-20-20v-4H80v4
				C80,158.48,94.048,173.576,112,175.592z"
          />
          <rect x="176" y="104" width="16" height="16" />
          <rect x="48" y="104" width="16" height="16" />
          <path
            d="M376,272c-46.416,0-86.32,28.392-103.28,68.712C264.68,342.856,256.392,344,248,344c-20.304,0-39.56-6.336-56-18.232V240
				h-16v160h19.44L120,469.152L44.56,400H64V224H48v160H3.44L120,490.848L236.56,384H192v-39.16c16.984,9.904,36.048,15.16,56,15.16
				c6.424,0,12.8-0.608,19.088-1.688C265.136,366.576,264,375.144,264,384c0,61.76,50.24,112,112,112s112-50.24,112-112
				S437.76,272,376,272z M376,480c-52.936,0-96-43.064-96-96c0-52.936,43.064-96,96-96c52.936,0,96,43.064,96,96
				C472,436.936,428.936,480,376,480z"
          />
          <rect x="432" y="376" width="16" height="16" />
          <rect x="304" y="376" width="16" height="16" />
          <path
            d="M352,361.496V376h-16v16h16v24c0,8.824-7.176,16-16,16v16h80v-16h-52.296c2.736-4.712,4.296-10.176,4.296-16v-24h48v-16
				h-48v-14.504C368,347.44,379.44,336,393.496,336H416v-16h-22.504C370.608,320,352,338.616,352,361.496z"
          />
          <rect x="80" y="384" width="16" height="16" />
          <rect x="80" y="240" width="16" height="128" />
          <rect x="336" y="96" width="16" height="112" />
          <rect x="336" y="224" width="16" height="16" />
        </g>
      </g>
    </g>
  </svg>
);

export default FX;
